import markerSDK from '@marker.io/browser'

export default defineNuxtPlugin(() => {
  markerSDK.loadWidget({
    project: '64e5a66f33f9d7a01ff9e6f1',
  })
})
